import React, { useMemo } from 'react'

export default function Loader({
  height,
  width,
}) {
  const isDesktop = __BROWSER__ && window.__GROMMET_THEME_SIZE__ === 'large'
  const spinnerWidth = useMemo(() => width || (isDesktop ? '56px' : '32px'), [width, isDesktop])
  const spinnerHeight = useMemo(() => height || (isDesktop ? '56px' : '32px'), [height, isDesktop])
  const svgLoader = useMemo(() => (
    <svg
      style={{
        animation: 'rotate 0.6s linear infinite',
        transformOrigin: 'center center',
      }}
      width={spinnerWidth}
      height={spinnerHeight}
      viewBox="0 0 46 46"
      version="1.1"
    >
      <title>spinner-large copy</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="spinner-large-copy"
          transform="translate(-5.000000, -5.000000)"
          strokeWidth="6"
        >
          <path
            d="M28,48 C39.045695,48 48,39.045695 48,28 C48,16.954305 39.045695,8 28,8 C16.954305,8 8,16.954305 8,28"
            id="Oval-Copy"
            stroke="#CCCACA"
            transform="translate(28.000000, 28.000000) rotate(-210.000000) translate(-28.000000, -28.000000) "
          />
          <path
            d="M28,48 C39.045695,48 48,39.045695 48,28 C48,16.954305 39.045695,8 28,8 C16.954305,8 8,16.954305 8,28"
            id="Oval"
            stroke="#333333"
            transform="translate(28.000000, 28.000000) rotate(-105.000000) translate(-28.000000, -28.000000) "
          />
        </g>
      </g>
    </svg>
  ), [spinnerHeight, spinnerWidth])

  return (
    <>
      <style>
        {`
            @keyframes rotate {
              100% {
                transform: rotate(360deg);
              }
            }
            .loadingtext {
              margin-left: 30px;
              font-weight: 400;
              font-size: 16px;
              align-self: center;
            }
            .svgwrapper {
              width: 100px;
              margin: 0 auto;
              text-align: center;
            }
            .loader {
              position: fixed;
              top: 46%;
              left: 0;
              margin: 0 auto;
              width: 100%;
              z-index: 999999;
            }
            .showbox {
              position: fixed;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              background-color: rgba(255, 255, 255, 0.6);
              z-index: 99999;
            }
        `}
      </style>
      <div className="showbox" />
      <div className="loader">
        <div className="svgwrapper">
          {svgLoader}
        </div>
      </div>
    </>
  )
}
